<template>
  <div class="dialog" :class="{ active: dialog }">
    <div class="dialog-content md">
      <div class="dialog-content-header">
        <div class="btn icon btn-coral no-hover">
          <em class="fal fa-folder-user"></em>
        </div>
        <div class="flex-grow-1 h4 ml-2 mr-2">Projetosxx</div>
        <button class="btn text icon" @click="close()">
          <em class="fal fa-times"></em>
        </button>
      </div>
      <span class="divider"></span>
      <div class="dialog-content-body">
        <div class="pa-1">
          <b-textfield
            placeholder="Buscar"
            name="search"
            type="search"
            appendIcon="fal fa-search"
            class="sm mb-0"
          />
        </div>
        <span class="divider"></span>
        <div class="list list-with-divider bg-contrast">
          <div v-for="i in 10" :key="i + 's'" class="list-item">
            <b-checkbox
              v-model="projetos"
              :inputValue="i"
              :id="'projeto' + i"
            >
              <template #label>
                <div class="paragraph flex-grow-1">Posição</div>
                <div class="paragraph xs">Empresa</div>
              </template>
            </b-checkbox>
          </div>
        </div>
      </div>
      <span class="divider"></span>
      <div class="dialog-content-footer">
        <span class="paragraph text-color-light">{{ projetos.length }}/10</span>
        <span class="flex-grow-1" />
        <button class="btn outlined sm" @click="clear()">Limpar</button>
        <button class="btn btn-coral sm">Aplicar</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'projetosModal',
  data () {
    return {
      dialog: false,
      projetos: []
    }
  },
  methods: {
    open () {
      this.dialog = true
    },
    close () {
      this.dialog = false
    },
    clear () {
      this.projetos = []
    }
  }
}
</script>
